/**
 * useDeleteRecording Hook
 * React Query mutation hook for deleting recordings
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteRecording } from '../api/recordingsApi';

/**
 * Delete a recording with optimistic updates
 * @returns Mutation hook for deleting recordings
 */
export function useDeleteRecording() {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: (recordingId: string) => deleteRecording(recordingId),
    onSuccess: () => {
      // Invalidate recordings list to refetch after deletion
      queryClient.invalidateQueries({ queryKey: ['recordings'] });
    },
    retry: 1,
  });
}
